import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot , CanLoad, Route} from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const url: string = state.url;

        return this.checkLogin(url);
    }
    canLoad(route: Route): boolean {
        const url = `/${route.path}`;

        return this.checkLogin(url);
    }
    checkLogin(url: string): boolean {
        var currentUser = this.authenticationService.currentUserValue || undefined;
        if (currentUser != undefined && currentUser.username != '') {
            console.log('Current User:' + currentUser.username);
            // authorised so return true
            return true;
        }
        // Navigate to the login page with extras
        this.router.navigate(['/login'], { queryParams: { }});
        return false;
      }
}